import * as Icons from "@nova/component-icons"
import { EventKind } from "@nova/schemas"
import { Notification } from "../Notification"
import { LayerTypeIcon } from "../NotificationIcons"
import { NotificationKindProps } from "./types"

type ProcessingKind = EventKind.LayerProcessed | EventKind.LayerProcessingFailed

export const ProcessingNotification = ({
    notification,
    copy,
}: NotificationKindProps<ProcessingKind>) => (
    <Notification notification={notification}>
        <Notification.Icon>
            <LayerTypeIcon
                layerType={notification.data.layerType}
                badge={notification.kind === EventKind.LayerProcessed ? "success" : "failure"}
            />
        </Notification.Icon>
        <Notification.Content>
            <Notification.Heading>
                <Notification.Title>{copy.title}</Notification.Title>
                {copy.subtitle && <Notification.Subtitle>{copy.subtitle}</Notification.Subtitle>}
            </Notification.Heading>
            {copy.body && <Notification.Body>{copy.body}</Notification.Body>}
            {notification.projectId && (
                <Notification.Action
                    label="Go to layer"
                    RightIcon={Icons.ArrowRight}
                    to={{
                        projectId: notification.projectId,
                        entityId: notification.data.layerId,
                    }}
                />
            )}
        </Notification.Content>
    </Notification>
)
